<template>
    <section class="p-fabrics">
        <div class="container">
            <v-tabs v-model="tab">
                <v-tab key="search">Ткани</v-tab>

                <v-tab key="rare">Принты</v-tab>

                <v-tabs-items v-model="tab">
                    <v-tab-item key="search">
                        <div class="p-fabrics__inner section">
                            <h2 class="title">Каталог тканей</h2>
                            <div class="input p-fabrics__search">
                                <input class="input__text" type="search" v-model="fabric_name" placeholder="Поиск тканей">
                            </div>
                            <div class="p-fabrics__filter section-small">
                                <div class="p-fabrics__filter-inner">
                                    <label :for="'fabricq'" checked="checked" class="p-fabrics__filter-item">
                                        <input class="p-fabrics__filter-item-input" type="radio" v-model="fabric_product_id" id="fabricq" :value="0">
                                        <span class="p-fabrics__filter-item-text">Все</span>
                                    </label>
                                    <div v-for="product in fabric_products" class="p-fabrics__filter-item">
                                        <label :for="'fabric'+product.id">
                                            <input name="filterFabrics" class="p-fabrics__filter-item-input"
                                                   type="radio"
                                                   v-model="fabric_product_id"
                                                   :value="product.id" :id="'fabric'+product.id">
                                            <span class="p-fabrics__filter-item-text">{{ product.name }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="p-fabrics__list">
                                <section class="portfolio-item" v-for="fabric in fabrics" data-aos="slide-up" data-aos-offset="100" data-aos-easing="ease-out-back">
                                    <img class="portfolio-item__img lazy" :src="fabric.media.crop"
                                         :alt="fabric.name" v-simple-magnifier v-if="windowWidth >= 992">
                                    <img class="portfolio-item__img lazy" :src="fabric.media.crop"
                                         :alt="fabric.name" v-else>
                                    <div class="p-fabrics__item-inner portfolio-item__inner">
                                        <h2 class="p-fabrics__item-title portfolio-item__title h4">
                                            {{ fabric.name }}
                                        </h2>
                                        <strong>Используется в изделиях:</strong>
                                        <a v-for="product in fabric.products" class="link p-fabrics__item-link" :href="product.url">
                                            {{product.name}}
                                        </a>
                                    </div>
                                </section>
                            </div>
                            <button class="p-fabrics__more btn" @click="loadMore" v-if="this.page <= this.last_page">
                                Загрузить ещё
                            </button>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="rare">
                        <div class="p-fabrics__inner section">
                            <h2 class="title">Каталог принтов</h2>
                            <div class="p-fabrics__search input">
                                <input class="input__text" type="search" v-model="print_name" placeholder="Поиск принтов">
                            </div>
                            <div class="p-fabrics__filter section-small">
                                <div class="p-fabrics__filter-inner">
                                    <label :for="'fabricp'" checked="checked" class="p-fabrics__filter-item">
                                        <input class="p-fabrics__filter-item-input" type="radio" v-model="fabric_product_id" id="fabricp" :value="0">
                                        <span class="p-fabrics__filter-item-text">Все</span>
                                    </label>
                                    <div v-for="product in print_products" class="p-fabrics__filter-item">
                                        <label :for="'fabric'+product.id">
                                            <input name="filterFabrics" class="p-fabrics__filter-item-input"
                                                   type="radio"
                                                   v-model="print_product_id"
                                                   :value="product.id" :id="'print'+product.id">
                                            <span class="p-fabrics__filter-item-text">{{ product.name }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="p-fabrics__list">
                                <section class="portfolio-item" v-for="fabric in prints" data-aos="slide-up" data-aos-offset="100" data-aos-easing="ease-out-back">
                                    <img class="portfolio-item__img lazy" :src="fabric.media.crop"
                                         :alt="fabric.name" v-simple-magnifier v-if="windowWidth >= 992">
                                    <img class="portfolio-item__img lazy" :src="fabric.media.crop"
                                         :alt="fabric.name" v-else>
                                    <div class="p-fabrics__item-inner portfolio-item__inner">
                                        <h2 class="p-fabrics__title portfolio-item__title h4">
                                            {{ fabric.name }}
                                        </h2>
                                        <strong>Используется в изделиях:</strong>
                                        <a v-for="product in fabric.products" class="link p-fabrics__item-link" :href="product.url">
                                            {{product.name}}
                                        </a>
                                    </div>
                                </section>
                            </div>
                            <button class="p-fabrics__more btn" @click="loadMorePrints" v-if="this.print_page <= this.print_last_page">
                                Загрузить ещё
                            </button>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </section>
</template>

<script>
import VSimpleMagnifier from 'v-simple-magnifier';

export default {
    name: "Catalog",
    components: {VSimpleMagnifier},

    data: () => ({
        tab: null,
        windowWidth: null,
        fabric_products: [],
        print_products: [],
        fabric_product_id: 0,
        print_product_id: 0,
        fabrics: [],
        prints: [],
        print_name: '',
        fabric_name: '',
        limit: 40,
        page: 1,
        print_page: 1,
        last_page: null,
        print_last_page: null
    }),

    created() {
        this.loadMore();
        this.loadMorePrints();
        window.addEventListener('scroll', this.handleResize, {passive: true});
    },
    destroyed() {
        window.addEventListener('scroll', this.handleResize, {passive: true});
    },
    watch: {
        fabric_product_id: async function (val) {
            this.page = 1;
            this.last_page = 1;
            this.fabrics = [];
            this.loadMore();
        },
        print_product_id: async function (val) {
            this.print_page = 1;
            this.print_last_page = 1;
            this.prints = [];
            this.loadMorePrints();
        },
        fabric_name: async function (val) {
            this.page = 1;
            this.last_page = 1;
            this.fabrics = [];
            this.loadMore();
        },
        print_name: async function (val) {
            this.print_page = 1;
            this.print_last_page = 1;
            this.prints = [];
            this.loadMorePrints();
        }
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        loadMore: function() {
            if(!this.last_page || this.page <= this.last_page) {
                this.$http.get(
                    '/api/fabrics-catalog/fabrics?page='+this.page+'&name='+this.fabric_name+'&product_id='+this.fabric_product_id)

                    .then(res => {
                    this.fabric_products = res.data.data.products;
                    res.data.data.data.forEach((el) => {
                        this.fabrics.push(el);
                    });
                    this.page++;
                    this.last_page = res.data.last_page;
                });
            }
        },
        loadMorePrints: function() {
            if(!this.print_last_page || this.print_page <= this.print_last_page) {
                this.$http.get('/api/fabrics-catalog/prints?page='+this.print_page+'&name='+this.print_name+'&product_id='+this.print_product_id).then(res => {
                    this.print_products = res.data.data.products;
                    res.data.data.data.forEach((el) => {
                        this.prints.push(el);
                    });
                    this.print_page++;
                    this.print_last_page = res.data.last_page;
                });
            }
        }
    }
}
</script>
